var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Loading-mask" }, [
    _c("div", {
      ref: "loading",
      staticClass: "loading__img",
      attrs: { id: "lottie" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }